import React from "react";
import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { DeviceConnectedLogo, DeviceDisconnectedLogo } from "../../../Logo/logos";
import { BatteryIcon } from "../../../icons/StatusIcons";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";
import { formatDoSensorDashboardDateTime } from "../../../../utils/doSensorDateTime";

const reading = (value, unit) => value == null || !Number.isFinite(Number(value))
  ? "--" : `${Number(value).toFixed(2)} ${unit}`;

const DoSensorWrap = ({ name, deviceId, isExpired }) => {
  const { data, status } = useLiveDevice(isExpired ? null : deviceId, { watchStatus: true });
  const active = !isExpired && status === "active";
  const lastUpdated = formatDoSensorDashboardDateTime(data?.date_time);

  return (
    <div
      className="device-card-flow"
      style={{ backgroundImage: active ? "url(/images/flow.gif)" : "url(/images/flow.png)" }}
    >
      <div className="device-card-head">
        <Tooltip title={name || String(deviceId)} placement="top">
          <Link to={`/device-detail/${deviceId}`} style={{ textDecoration: "none" }}>
            <div className="device-card-title">{name || deviceId}</div>
          </Link>
        </Tooltip>
        {!isExpired && (
          <div className="device-card-status">
            <Tooltip title={active ? "Device Connected" : "Device Disconnected"}>
              {active ? <DeviceConnectedLogo /> : <DeviceDisconnectedLogo />}
            </Tooltip>
            <Tooltip title={data?.battery == null ? "Power status unavailable" : Number(data.battery) === 1 ? "Power On" : "Power Off"}>
              <BatteryIcon on={data?.battery == null ? null : Number(data.battery) === 1} />
            </Tooltip>
          </div>
        )}
      </div>

      <div className="device-card-metrics">
        <div className="device-card-metric">
          {isExpired ? (
            <div className="device-card-expired">Subscription Expired</div>
          ) : (
            <>
              <div className="device-card-metric-label">Dissolved oxygen:</div>
              <div className="device-card-metric-value">{reading(data?.dissolved_oxygen, "mg/L")}</div>
            </>
          )}
        </div>
        {!isExpired && (
          <div className="device-card-metric">
            <div className="device-card-metric-label">Temperature:</div>
            <div className="device-card-metric-value">{reading(data?.temp, "°C")}</div>
          </div>
        )}
      </div>

      {!isExpired && (
        <div className="device-card-updated">
          <div className="device-card-metric">
            <div className="device-card-metric-label">Last Updated:</div>
            <div className="device-card-metric-value device-card-metric-stamp">{lastUpdated}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DoSensorWrap;
